import { PDRModule } from '../PDRModule';
export class ElementModule extends PDRModule {
    async ensure() {
        throw new Error('PDR.element.ensure is removed, use PDR.mfe.load to microfrontends instead.');
    }
    exists() {
        throw new Error('PDR.element.exists is removed!');
    }
}
